import { render, staticRenderFns } from "./Religion.vue?vue&type=template&id=c2737a0e"
import script from "./Religion.vue?vue&type=script&lang=js"
export * from "./Religion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports